import {Component, OnInit} from '@angular/core';
import {Globals} from 'src/app/Globals';
import {HttpService} from 'src/app/services/http-service';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import { getSignupUserId, patchSignupProgress } from '../signup-user';

@Component({selector: 'app-verification', templateUrl: './verification.component.html', styleUrls: ['./verification.component.scss']})
export class VerificationComponent implements OnInit {

    public previewImage = false;
    public previewImageUrl = '';
    globals = Globals;
    expiryDate: any;
    isLoadingResults = false;
    httpSub$: Subscription = null;
    model: any = {};
    fileToUpload: File = null;
    comingFrom: any;
    editMode = false;
    driverDetails: any;
    submitted = true;
    userId = '';

    constructor(private service: HttpService, private router: Router, private toastr: ToastrService) {}

    ngOnInit() {
        this.userId = getSignupUserId();
        if (!this.userId) {
            this.service.showError('Please complete registration first.', 'ERROR');
            this.router.navigate(['/registration/registration-details']);
        }
    }

    uploadPackageImage(files: FileList, type) {
        console.log(type);
        if (files[0].type === 'image/gif') {
            this.service.showError('Gif images are not allowed', 'Profile details');
            return;
        }
        this.fileToUpload = files.item(0);
        this.isLoadingResults = true;
        this.httpSub$ = this.service.uploadImage(this.globals.urls.signUp.noauth.uploadImage, this.fileToUpload).subscribe(res => {
            console.log(res);
            this.isLoadingResults = false;
            if (type === 1) {
                this.model.identityFrontImage = res.data.url;
            } else if (type === 2) {
                this.model.identityBackImage = res.data.url;
            }
            console.log(this.model);
        }, err => {
            this.isLoadingResults = false;
        },);
    }

    goToNextStep() {
        const url = this.globals.urls.signUp.noauth.uploadVerificationDocument;
        const userId = getSignupUserId();
        if (!userId) {
            this.service.showError('Please complete registration first.', 'ERROR');
            this.router.navigate(['/registration/registration-details']);
            return;
        }
        const params = {
            _id: userId,
            merchantId: userId,
            identityFrontImage: this.model.identityFrontImage,
            identityBackImage: this.model.identityBackImage
        };
        console.log(params);
        this.service.postRequest(url, params).subscribe(res => {
            if (res.success === 1) {
                console.log('SUCCESS', res.message);
                this.service.showSuccess(res.message, 'Success');
                patchSignupProgress({ signupStepCompleted: 1 });
                this.router.navigate(['/registration/payout-setup']);
            } else {
                console.log('ERROR', res.message);
                this.service.showError(res.message, 'ERROR');
            }
        }, err => {
            console.log('err', err);
            this.service.showError(typeof err === 'string' ? err : ((err && err.message) || 'Failed to save documents'), 'ERROR');
        });
    }
}
